var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupportChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.992 16.5a.59.59 0 01-.362-1.058l3.876-3.01a.59.59 0 01.699-.02l2.042 1.413a.59.59 0 01.255.482l.01 1.598a.59.59 0 01-.591.595H3.992z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.015 16.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm-2.04-8.983c-.183.291-.275.579-.275.864 0 .138.057.267.171.387.117.117.26.175.428.175.285 0 .478-.169.58-.508.108-.324.24-.569.396-.734.156-.167.399-.252.729-.252.282 0 .511.083.689.248.18.165.27.368.27.608 0 .123-.03.236-.09.341a1.248 1.248 0 01-.216.288 9.39 9.39 0 01-.415.379 6.787 6.787 0 00-.521.499c-.13.138-.233.3-.311.486-.078.183-.117.4-.117.652 0 .202.053.353.158.455.108.102.24.153.396.153.3 0 .478-.156.535-.468.033-.147.057-.249.072-.306a.982.982 0 01.207-.369c.063-.072.146-.154.248-.247.368-.33.623-.564.764-.702.145-.141.268-.308.37-.5.105-.192.157-.415.157-.67 0-.324-.091-.624-.274-.9a1.837 1.837 0 00-.77-.653 2.602 2.602 0 00-1.152-.243c-.468 0-.877.096-1.228.288a2.107 2.107 0 00-.801.729zm1.44 5.62a.722.722 0 00.481.176c.177 0 .333-.06.468-.18a.628.628 0 00.202-.495.648.648 0 00-.193-.477.648.648 0 00-.477-.194.669.669 0 00-.684.671c0 .213.068.38.203.5z",
    fill: "currentColor"
  })));
}

export default SvgSupportChat;